import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumbs = () => {
  const location = useLocation();

  const routeMap = {
    '/partner-dashboard': 'Dashboard',
    '/create-lead': 'Create Lead',
    '/lead-details': 'Lead Details',
    '/partner-profile': 'Profile',
    '/admin-partner-management': 'Partner Management',
    '/partner-authentication': 'Authentication',
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
  
  const breadcrumbs = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
    return {
      label: routeMap?.[path] || segment?.split('-')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' '),
      path: path,
      isLast: index === pathSegments?.length - 1,
    };
  });

  if (breadcrumbs?.length === 0 || location?.pathname === '/partner-authentication') {
    return null;
  }

  return (
    <nav className="flex items-center gap-2 px-6 py-3 bg-muted/30 border-b border-border text-sm" aria-label="Breadcrumb">
      <Link
        to="/partner-dashboard"
        className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors duration-200"
      >
        <Icon name="Home" size={16} />
        <span className="hidden sm:inline">Home</span>
      </Link>
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
          {crumb?.isLast ? (
            <span className="text-foreground font-medium truncate max-w-[200px] sm:max-w-none">
              {crumb?.label}
            </span>
          ) : (
            <Link
              to={crumb?.path}
              className="text-muted-foreground hover:text-foreground transition-colors duration-200 truncate max-w-[150px] sm:max-w-none"
            >
              {crumb?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default NavigationBreadcrumbs;